import Step2Content from "@/features/items/components/Step2Content";

export default {
  // Common
  common: {
    open: "Open",
    from: "From",
    to: "To",
    deselectAll: "Deselect All",
    uploadFiles: "Upload Files",
    appName: "Cost Control",
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    save: "Save",
    saved: "Saved",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    update: "Update",
    search: "Search",
    filter: "Filter",
    clear: "Clear",
    apply: "Apply",
    reset: "Reset",
    confirm: "Confirm",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    yes: "Yes",
    no: "No",
    all: "All",
    none: "None",
    select: "Select",
    selected: "selected",
    actions: "Actions",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    total: "Total",
    items: "Items",
    showMore: "Show more",
    showLess: "Show less",
    noData: "No data available",
    noResults: "No results found",
    import: "Import",
    export: "Export",
    exporting: "Exporting",
    fileFailedToUpload: "File failed to upload",
    exportPdf: "PDF",
    exporttPdf: "Export PDF",
    exportXlsx: "XLSX",
    exportCsv: "CSV",
    advancedFilters: "Advanced Filters",
    applyFilter: "Apply Filter",
    resetFilters: "Reset Filters",
    goToPage: "Go to page",
    show: "Show",
    noOption: "No option",
    default: "Default",
    ascending: "Ascending",
    descending: "Descending",
    oldest: "Oldest",
    lowest: "Lowest",
    highest: "Highest",
    newest: "Newest",
    alphabeticalAscending: "Alphabetical Ascending",
    alphabeticalDescending: "Alphabetical Descending",
    chronologicalAscending: "Chronological Ascending",
    chronologicalDescending: "Chronological Descending",
    removeFilter: "Remove filter",
    view: "View",
    exportExcel: "Excel",
    saveDraft: "Save Draft",
    discard_exit: "Discard & Exit",
    chooseFile: "Choose file",
    dropFilesHere: "Drop files here to upload",
    submit: "Submit",
    type: "Type",
  },

  // Navigation
  nav: {
    components: "Components",
    dashboard: "Dashboard",
    management: "Management",
    stockManagement: "Stock Management",
    inventory: "Inventory",
    orders: "Orders",
    orderManagement: "Order Management",
    purchaseOrders: "Purchase Orders",
    receivingQc: "Receiving & QC",
    dataManagement: "Data Management",
    items: "Items",
    rawMaterials: "Raw Materials",
    preparedItems: "Prepared Items",
    preparationManagement: "Preparation Management",
    producedOutput: "Produced Output",
    suppliers: "Suppliers",
    costCenters: "Cost Centers",
    expenses: "Expenses",
    users: "Users",
    settings: "Settings",
    profile: "Profile",
    logout: "Log out",
    transfersManagement: "Transfers Management",
    transfers: "Transfers",
    incomingTransfers: "Incoming Transfers",
    incomingRequests: "Incoming Requests",
    centralKitchen: "Central Kitchen",
    branch: "Branch",
    requestsSent: "Requests Sent",
    branchToBranchTransfers: "Branch to Branch Transfers",
  },

  // Auth
  auth: {
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signUp: "Sign up",
    signIn: "Sign in",
    welcomeBack: "Welcome back",
    loginSubtitle: "Enter your credentials to access your account",
    registerSubtitle: "Create a new account to get started",
    name: "Full Name",
  },

  // Validation
  validation: {
    required: "{{field}} is required",
    email: "Please enter a valid email address",
    minLength: "{{field}} must be at least {{min}} characters",
    maxLength: "{{field}} must be at most {{max}} characters",
    passwordMatch: "Passwords do not match",
    invalidCredentials: "Invalid email or password",
    min: "{{field}} must be at least {{min}}",
    max: "{{field}} must be at most {{max}}",
    positive: "{{field}} must be a positive number",
    integer: "{{field}} must be a whole number",
  },

  // Dashboard
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome, {{name}}",
    overview: "Overview",
    totalExpenses: "Total Expenses",
    totalBudget: "Total Budget",
    budgetUtilization: "Budget Utilization",
    recentActivity: "Recent Activity",
    quickActions: "Quick Actions",
    expensesByCategory: "Expenses by Category",
    monthlyTrend: "Monthly Trend",
    topCostCenters: "Top Cost Centers",
    pendingApprovals: "Pending Approvals",
  },

  // Items
  items: {
    title: "Raw Materials",
    createItem: "Create Item",
    editItem: "Edit Item",
    edit: {
      confirmModal: {
        title: "Confirm Item Update",
        subtitle: "Are you sure you want to save these changes?",
        description: "The item details will be updated.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Save Changes",
      },
    },
    deleteItem: "Delete Item",
    deleteConfirm: "Are you sure you want to delete this item?",
    cannotDeleteSingle: 'Cannot Delete "{{name}}"',
    cannotDeleteSingleDescription:
      "This item is already in use and cannot be deleted to preserve existing records.",
    deleteSingleTitle: 'Delete "{{name}}"?',
    deleteSingleSubtitle: "This item hasn't been used yet.",
    deleteSingleDescription:
      "Deleting it will permanently remove it from the system.",
    cannotDeleteMultiple: "Cannot Delete {{count}} Selected Items",
    cannotDeleteMultipleDescription:
      "All selected items are already in use and cannot be deleted.",
    deleteMultipleTitle: "Delete {{count}} Selected Items?",
    deleteMultipleSubtitle: "These items haven't been used yet.",
    deleteMultipleDescription:
      "Deleting them will permanently remove them from the system.",
    deleteMultipleItems: "Delete Items",
    someItemsCantBeDeleted: "Some Items Can't Be Deleted",
    someItemsCantBeDeletedSubtitle:
      "Only items that haven’t been used will be deleted.",
    someItemsCantBeDeletedDescription:
      "Some of the selected items are already in use and cannot be deleted.",
    itemsCanBeDeleted: "{{deletable}} of {{total}} items can be deleted",
    deleteEligibleItems: "Delete Eligible Items",
    deactivateItem: "Deactivate Item",
    deactivateMultipleItems: "Deactivate Items",
    cannotDeactivateSingle: 'Cannot Deactivate "{{name}}"',
    cannotDeactivateSingleDescription:
      "This item is currently in use and must remain active.",
    deactivateSingleTitle: 'Deactivate "{{name}}"?',
    deactivateSingleSubtitle:
      "This item will no longer be available for selection.",
    deactivateSingleDescription: "You can reactivate it later if needed.",
    cannotDeactivateMultiple: "Cannot Deactivate {{count}} Selected Items",
    cannotDeactivateMultipleDescription:
      "All selected items are currently in use and must remain active.",
    deactivateMultipleTitle: "Deactivate {{count}} Selected Items?",
    deactivateMultipleSubtitle:
      "These items will no longer be available for selection.",
    deactivateMultipleDescription: "You can reactivate them later if needed.",
    someItemsCantBeDeactivated: "Some Items Can't Be Deactivated",
    someItemsCantBeDeactivatedSubtitle:
      "Only items not in use will be deactivated.",
    someItemsCantBeDeactivatedDescription:
      "Some of the selected items are currently in use and must remain active.",
    deactivateEligibleItems: "Deactivate Eligible Items",
    itemName: "Item Name",
    sku: "SKU",
    category: "Category",
    subcategory: "Subcategory",
    baseUOM: "Base UOM",
    preferredSupplier: "Preferred Supplier",
    costPerPurchaseUOM: "Purchase Price",
    purchaseUOM: "Purchase UOM",
    caseSize: "Pack Size",
    unitCost: "Unit Cost",
    selectCategory: "Select Category",
    selectSubcategory: "Select Subcategory",
    searchPlaceholder: "Search by name, SKU, ...",
    searchValidationError: "Special characters are not allowed",
    tags: "Tags",
    totalItems: "Total: {{count}} Items",
    sortByDate: "Sort by Date",
    selectedItems: "{{count}} Selected",
    status: "Status /",
    mixedStatus: "Mixed",
    categorySubcategory: "Category / Sub",
    learnMore: "Learn More",
    getStarted: "Get Started",
    quickGuide: "Quick Guide to Creating Items",
    createItemDescription: "Step-by-step guide to quickly manage your items.",
    createItemContent: "Here's how to add items in just 2 easy steps:",
    importantNotes: "Important Notes",
    importantNote1: "You can add items one subcategory at a time.",
    importantNote2:
      "You can save your progress as a draft anytime and continue later.",
    step1Title: "Step 1",
    step1Subtitle: "Item Basics",
    step1Description1: "Select a category and subcategory.",
    step1Description2:
      "Add item names in English and Arabic based on the selected subcategory.",
    step2Title: "Step 2",
    step2Subtitle: "Item Setup",
    step2Description1: "Select one or multiple items you added in Step 1.",
    step2Description2: "Add cost per purchase UOM and case size.",
    step2Description3: "Save your changes before moving to another item.",
    needHelp: "Need help?",
    importItems: "Import Items",
    importItemsSubtitle:
      "Upload a filled document to add multiple items at once.",
    importItemsDescription:
      "Use this template to ensure your items are formatted correctly before uploading.",
    downloadTemplate: "Download Template",
    uploadDropzoneTitle:
      "Click to upload or drag and drop XLSX (Max. File Size: 30MB)",
    chooseFile: "Choose file",
    uploadFile: "Upload File",
    maxFileSizeErrorMessage:
      "File size exceeds the maximum allowed size of 30MB",
    noFileSelectedError: "Please select a file to import",
    fileShouldFollowTemplate: "The file should follow the template",
    pleaseUploadAndValidateFileFirst: "Please upload and validate a file first",
    noDataInFile: "The file contains no data",
    validationErrors: {
      worksheetNotFound: "Worksheet not found",
      expectedColumns: "The file should follow the template",
      invalidHeaders: "Invalid headers: {{headers}}",
      categoryRequired: "Category is required",
      invalidCategory: "Invalid category.",
      subcategoryRequired: "Subcategory is required",
      invalidSubcategory: "Invalid subcategory.",
      itemNameEnRequired: "Item Name EN is required",
      itemNameEnEnglishOnly:
        "Item Name EN must contain only English characters",
      duplicateItemName: "Duplicate item name '{{name}}' ",
      itemNameArRequired: "Item Name AR is required",
      itemNameArArabicOnly: "Item Name AR must contain only Arabic characters",
      baseUOMRequired: "Base UOM is required",
      invalidBaseUOM: "Invalid Base UOM.",
      purchaseUOMRequired: "Purchase UOM is required",
      invalidPurchaseUOM: "Invalid Purchase UOM.",
      packSizeRequired: "Pack Size is required",
      packSizePositiveNumber: "Pack Size must be a positive number",
      parLevelRequired: "Par Level is required",
      parLevelPositiveNumber: "Par Level must be a positive number",
      invalidTags: "Invalid tags: {{tags}}.",
      errorReadingFile: "Error reading file: {{error}}",
      unknownError: "Unknown error",
    },
    addingItems: "Adding Items...",
    addingItemsSubtitle: "This may take a few moments.",
    itemsProgress: "{{current}}/{{total}} Items",
    itemDetails: "Item Details",
    suppliers: "Suppliers",
    activityLog: "Activity Log",
    statusDescription:
      "Controls whether this item is available for use and visible in the system.",
    baseUOMDescription: "The unit used for inventory tracking.",
    purchaseUOMDescription: "The unit in which you usually buy this item.",
    caseSizeDescription: "The quantity of the item in one purchase unit.",
    tagsDescription:
      "Add labels to help categorize and filter this item across the system.",
    tagsAdded: "Tags Added",
    parLevel: "Par Level",
    parLevelDescription:
      "The minimum quantity to keep in stock before reordering is required.",
    backupSuppliers: "Backup suppliers",
    supplierName: "Supplier's Name",
    purchasePrice: "Purchase Price",
    noSuppliers: "No Assigned Suppliers",
    notAssigned: "Not Assigned",
    noSuppliersDescription:
      "This item doesn't have any suppliers assigned yet.",
    goToSuppliers: "Go to Suppliers",
    noActivity: "No Activity Yet",
    noActivityDescription:
      "Activity history will appear here once actions are taken on this item.",
    source: "Source",
    itemCreated: "Create Item",
    itemUpdated: "Item Updated",
    statusChanged: "Status Changed",
    activityLogChangeFromTo: "{{field}}: {{from}} → {{to}}",
    activityLogEmptyValue: "—",
    activityLogIngredientDeleted: "{{name}} ingredient is deleted",
    activityLogIngredientAdded: "{{name}} ingredient is added",
    by: "By",
    step1Content: "Choose category and subcategory, then enter all item names.",
    step2Content:
      "Set units, pack size, and tags, then apply them to other items where applicable.",
    addItemNames: "Add Item Names",
    leaveThisStep: "Leave This Step?",
    leaveThisStepSubTitle: "Items can only be added under one subcategory.",
    leaveThisStepDescription:
      "Going back to change the subcategory will remove the items you’ve already added.",
    stayOnThisStep: "Stay on This Step",
    leaveAndClear: "Leave and Clear Items",
    itemsCleared: "Items cleared.",
    itemsClearedDescription: "You can now select a different subcategory.",
    addItem_s: "Add Item/s",
    itemNameEn: "English Name",
    itemNameEnPlaceholder: "English name here",
    itemNameAr: "Arabic Name",
    itemNameArPlaceholder: "Arabic name here",
    item: "Item",
    addItems: "Add Items",
    saveAsDraft: "Save as draft",
    saveDraftModalTitle: "Draft Saved!",
    saveDraftModalSubTitle: "Your progress has been saved as a draft.",
    saveDraftModalDescription:
      "You can return later to continue editing the item details.",
    saveDraftModalCancel: "Exit Form",
    saveDraftModalConfirm: "Continue Editing",
    addedSuccessfully: "Supplier added successfully",
    addedSuccessfullyDescription:
      "Your supplier is now available and ready to use.",
    addedItems: "Added Items",
    selectItems: "Select Item/s",
    selected: "Selected",
    allItems: "All Items",
    addItemDetails: "Add Item Details",
    baseUOMHint: "The unit used for inventory tracking",
    selectBaseUOM: "Select Unit (kg, liter, piece, etc)",
    purchaseUOMHint: "The unit in which you usually buy this item",
    selectPurchaseUOM: "Select Unit (box, carton, sack,...",
    packSize: "Pack Size",
    packSizeHint: "The quantity of the item in one purchase unit",
    packSizePlaceholder: "12kg per carton",
    parLevelHint:
      "The minimum quantity to keep in stock before reordering is required.",
    minimum: "Minimum",
    tagsHint:
      "Add labels to help categorize and filter this item across the system.",
    multipleSelected: "Multiple Selected",
    mixedInput: "Mixed input",
    itemsAddedSuccessfully: "Items added successfully",
    itemsAddedSuccessfullyDescription:
      "Your items were added, but they’re not linked to a supplier yet.",
    itemsAddedSuccessfullyCancel: "View Items",
    itemsAddedSuccessfullyConfirm: "Go to Suppliers",
    itemsAddedSuccessfullyContent:
      "*To start using them, link the items to supplier/s.",
    exitWarningModalTitle: "Exit Without Saving?",
    exitWarningModalSubTitle: "This form contains unsaved item details.",
    exitWarningModalDescription:
      "Exiting now will permanently delete all entered data.",
    exitWarningModalCancel: "Discard & Exit",
    exitWarningModalConfirm: "Save Draft",
    unSavedDataWarningModalTitle: "Unsaved Changes",
    unSavedDataWarningModalSubTitle: "You haven’t saved the item details yet.",
    unSavedDataWarningModalDescription:
      "Deselecting or selecting another item will remove the entered data.",
    unSavedDataWarningModalCancel: "Discard Changes",
    unSavedDataWarningModalConfirm: "Save & Continue",
    deselectAll: "Deselect All",
    backWarningModalDescription:
      "If you go back, all items details will be removed",
    backWarningModalConfirm: "Save & Go Back",
    applyMultipleFilters: "Apply multiple filters to narrow down your results.",
    draftModalTitle: "You have unfinished items!",
    draftModalSubTitle: "You started creating items but didn't finish them.",
    draftModalDescription:
      "To create new items, complete or delete the existing drafts.",
    draftModalCancel: "Create New Items",
    draftModalConfirm: "Complete Form",
    draft: "Draft",
    supplier: "Supplier",
    exitWarningModalConfirmNoDraft: "Continue",
    deleteAllItems: "Remove All",

    errors: {
      nameEnRequired: "English name is required",
      englishOnly: "Only English characters are allowed",
      nameArRequired: "Arabic name is required",
      arabicOnly: "Only Arabic characters are allowed",
      duplicateName: "This item name already exists",
      packSizeRequired: "Pack Size is required",
      greaterThanZero: "Pack Size must be greater than zero",
      parLevelRequired: "Par Level is required",
      positiveNumber: "Par Level must be greater than zero",
    },
    export: {
      status: "Status",
      itemName: "Item Name",
      sku: "SKU",
      category: "Category",
      subcategory: "Subcategory",
      preferredSupplier: "Preferred Supplier",
      purchaseUOM: "Purchase UOM",
      purchasePrice: "Purchase Price",
      unitCost: "Unit Cost",
    },
    deletedSuccessfully: "Item(s) deleted successfully.",
    deletedSingleSuccess: "{{name}} deleted successfully.",
    deletedMultipleSuccess: "Items deleted successfully.",
    activatedSingleSuccess: "{{name}} activated successfully.",
    activatedMultipleSuccess: "Items activated successfully.",
    deactivatedSingleSuccess: "{{name}} deactivated successfully.",
    deactivatedMultipleSuccess: "Items deactivated successfully.",
    deleteDraft: "Delete Draft",
    deleteDraftDescription:
      "This draft hasn’t been submitted yet. Deleting it will permanently remove all saved changes.",
    deleteDraftSubtitle: "This action can’t be undone.",
    confirmDeleteDraft: "Yes, Delete Draft",
    cancelDeleteDraft: "No, Keep Draft",
    draftDeleted: "Draft deleted",
    draftDeletedDescription: "The draft has been removed successfully.",
  },

  // Suppliers
  suppliers: {
    supplierDetails: "Supplier Details",
    submit: "Submit Supplier",
    supplier: "Supplier",
    deleteAllItems: "Delete All Items",
    removeAllItems: "Remove All Items",
    pickDate: "Pick a date",
    title: "Suppliers",
    purchaseUOMPackSize: "Purchase UOM / Pack Size",
    createSupplier: "Create Supplier",
    editSupplier: "Edit Supplier",
    supplierName: "Supplier Name",
    code: "Code",
    email: "Email",
    phone: "Phone",
    address: "Address",
    quickGuide: "Quick Guide to Creating Suppliers",
    createSupplierDescription:
      "Step-by-step guide to easily set up and manage your suppliers.",
    createSupplierContent:
      "Here’s how to create a supplier in just 4 simple steps:",
    learnMore: "Learn More",
    getStarted: "Get Started",
    step1Title: "Step 1",
    step1title: "Basic Information.",
    step1Subtitle: "Supplier Info.",
    step1Description1: "Enter the supplier’s basic details such as name & type",
    step2Title: "Step 2 ",
    step2title: "Contact Information.",
    step2Subtitle: "Contact Info.",
    step2Description1:
      "Add contact details for communicating with the supplier.",
    step2Description2:
      "You can optionally include a contact person for direct communication.",
    step3Title: "Step 3",
    step3Subtitle: "Contract.",
    step3Description1: "Select the appropriate contract type for the supplier.",
    step3Description2:
      "If applicable, add contract dates and upload the contract document.",
    step4Title: "Food / Add Prices to items",
    step4: "Step 4",
    step4Subtitle: "Add Items & Prices.",
    step4Description1:
      "Select the items you purchase from this supplier from one or more subcategories.",
    step4Description2: "Set purchase prices for items, including bulk pricing.",
    step1ProgressTitle: "Enter the supplier's core details and type.",
    step2ProgressTitle:
      "Add contact details for communicating with the supplier.",
    step3ProgressTitle:
      "Define the contract type and attach agreement details, if applicable.",
    step4ProgressTitle:
      "Select the items you purchase from this supplier and set their prices.",

    importantNotes: "Important Notes",
    importantNote1:
      "Prices set under fixed contracts are locked for all purchased orders",
    importantNote2:
      "You can save your progress as a draft anytime and continue later",
    editQuickGuide: "Quick Guide to Editing Suppliers",
    editSupplierDescription:
      "Step-by-step guide to update and maintain your supplier details.",
    editSupplierContent: "Here’s how to edit a supplier in 4 steps:",
    editStep1Description1:
      "Update the supplier’s name, type, TRN / VAT number, and legal documents.",
    editStep2Description1:
      "Update phone number, email, location, and contact person.",
    editStep2Description2:
      "You can add or change a contact person for direct communication.",
    editStep3Description1:
      "Update the contract type, dates, and contract documents.",
    editStep3Description2: "Complete all required contract fields before saving.",
    editStep4Description1:
      "Add or remove items, add a new purchase UOM / pack size variant, and add a price for that variant.",
    editStep4Description2:
      "You can change supplier type (Main / Backup) from the item linkage.",
    editImportantNote1:
      "The latest supplier data is used in current views and new transactions.",
    editImportantNote2:
      "Committed and historical transactions keep the data captured at that time.",
    needHelp: "Need help?",
    englishName: "English Name",
    englishNamePlaceholder: "Enter Supplier English Name",
    arabicName: "Arabic Name",
    arabicNamePlaceholder: "Enter Supplier Arabic name",
    supplierType: "Supplier Type",
    mainSupplier: "Main Supplier",
    mainSupplierDescription:
      "Primary supplier used as the default and prioritized during ordering.",
    backupSupplier: "Backup Supplier",
    backupSupplierDescription:
      "Alternative supplier used when the main supplier is unavailable during ordering.",
    trnVatNumber: "TRN / VAT Number",
    trnVatNumberDescription: "Used for tax and invoicing purposes.",
    trnVatNumberPlaceholder: "Enter TRN / VAT Number",
    legalDocuments: "Legal Documents",
    legalDocumentsDescription:
      "Upload documents such as Commercial Registration and Tax Card.",
    legalDocumentsHint: "Formats: PDF, DOC, DOCX, Max file size: 50 MB.",
    dropzoneText: "Drop files here to upload",
    // Step 2 - Contact Information
    contactInformation: "Contact Information",
    contactPerson: "Contact Person",
    phoneNumber: "Phone Number",
    phonePlaceholder: "XX-XXXX-XXXX",
    emailPlaceholder: "text@domain.com",
    location: "Location",
    country: "Country",
    selectCountry: "Select",
    uae: "UAE",
    unitedArabEmirates: "United Arab Emirates",
    city: "City",
    selectCity: "Select",
    addressPlaceholder: "Building no., Street name, District/Neighborhood",
    addressHint: "0/50 Characters",
    addContactPerson: "Add Contact Person",
    addContactPersonHelper:
      "Check this box to provide a primary contact for the supplier.",
    contactPersonDetails: "Contact Person Details",
    editContactPerson: "Edit Contact Person",
    contactPersonName: "Contact Person Name",
    contactPersonNamePlaceholder: "Enter Contact Person Name",
    contactPersonPhone: "Contact Person Phone",
    contactPersonEmail: "Contact Person Email",
    saveContact: "Save",
    addAnotherPerson: "Add another person",
    deleteContactPersonTitle: 'Delete "{{name}}"?',
    deleteContactPersonSubTitle:
      "Are you sure you want to delete this contact person?",
    deleteContactPersonSubTitleDescription: "This action can't be undone.",
    deletePerson: "Delete Person",
    contactPersonRemovedSuccess: '"{{name}}" removed successfully.',
    // Step 3 - Contract
    contractDetails: "Contract Details",
    contractType: "Contract Type",
    fixedPriceAgreement: "Fixed-Price Agreement",
    fixedPriceAgreementDescription:
      "A contract with a set price that does not change over the agreement period.",
    standardSupplier: "Standard Supplier",
    standardSupplierDescription:
      "A supplier without a formal contract, providing goods or services on a flexible basis.",
    priceLockScope: "Price Lock Scope",
    priceLockDescription:
      "Prices defined here are locked and cannot be changed when creating purchase orders.",
    contractDate: "Contract Date",
    startDate: "Start Date",
    endDate: "End Date",
    contractDocuments: "Contract Documents",
    noUploadedDocuments: "No Uploaded Documents",
    documents: "Documents",
    uploadFiles: "Upload files",
    contractDocumentsHint: "Formats: PDF, DOC, DOCX. Max file size: 50 MB.",
    totalSuppliers: "Total: {{count}} Suppliers",
    draft: "Draft",
    draftModalTitle: "You have unfinished suppliers!",
    draftModalSubTitle:
      "You started creating suppliers but didn't finish them.",
    draftModalDescription:
      "To create new suppliers, complete or delete the existing drafts.",
    draftModalCancel: "Create New Suppliers",
    draftModalConfirm: "Complete Form",
    category: "Category",
    contractStatus: "Contract Status",
    upcoming: "Upcoming",
    expired: "Expired",
    assignedItemCount: "Assigned Items",
    actions: "Actions",
    emptySuppliers: "No Suppliers Added Yet",
    suppliers: "Suppliers",
    noStatus: "N/A",
    searchPlaceholder: "Search by supplier name",
    statusChangedSuccessfully: "Supplier(s) status changed successfully.",
    main: "Main",
    backup: "Backup",
    selectSupplierType: "Select Supplier Type",
    deactivateSingleTitle: 'Deactivate "{{name}}"?',
    deactivateSingleSubtitle: "This supplier hasn’t been used yet.",
    deactivateSingleDescription:
      "Once inactive, it won’t be available for selection.",
    deactivateSupplier: "Deactivate Supplier",
    deactivateMultipleTitle: "Deactivate {{count}} suppliers?",
    deactivateMultipleSubtitle: "These suppliers haven’t been used yet.",
    deactivateMultipleDescription:
      "Once inactive, they won’t be available for selection.",
    deactivateMultipleSuppliers: "Deactivate Suppliers",
    deletedSuccessfully: "Supplier(s) deleted successfully.",
    deleteSingleTitle: 'Delete "{{name}}"?',
    deleteSingleSubtitle: "This supplier hasn’t been used yet.",
    deleteSingleDescription:
      "Deleting it will permanently remove it from the system.",
    deleteMultipleTitle: "Delete {{count}} suppliers?",
    deleteMultipleSubtitle: "These suppliers haven’t been used yet.",
    deleteMultipleDescription:
      "Deleting them will permanently remove them from the system.",
    deleteMultipleSuppliers: "Delete Suppliers",
    deleteSupplier: "Delete Supplier",
    type: "Type",
    status: "Status",
    date: "Date",
    activityLogCreated: "Supplier created",
    activityLogUpdated: "Supplier updated",
    activityLogDescSetActive: "Supplier set to active",
    activityLogDescSetInactive: "Supplier set to inactive",
    activityLogStatusChanged: "Status changed",
    activityLogChangeFromTo: "{{field}}: {{from}} → {{to}}",
    activityLogEmptyValue: "—",
    noSuppliersMatchYourFilter: "No suppliers match your filter",
    assignedItems: "Assigned Items",
    deletedSingleSuccess: "{{name}} deleted successfully.",
    deletedMultipleSuccess: "Suppliers deleted successfully.",
    activatedSingleSuccess: "{{name}} activated successfully.",
    activatedMultipleSuccess: "Suppliers activated successfully.",
    deactivatedSingleSuccess: "{{name}} deactivated successfully.",
    deactivatedMultipleSuccess: "Suppliers deactivated successfully.",
    deleteDraft: "Delete Draft",
    deleteDraftDescription:
      "Are you sure you want to delete this draft? All supplier information will be lost.",
    deleteDraftSubtitle: "This action can't be undone.",
    cancelDeleteDraft: "Cancel",
    confirmDeleteDraft: "Delete Draft",
    draftDeleted: "Draft deleted",
    draftDeletedDescription: "The draft has been removed successfully.",
    tabs: {
      assignedItems: "Assigned Items",
      details: "Details & Activity",
    },
    details: {
      items: "Items",
      contractDetails: "Contract Details",
      noDate: "No Specified Date",
      activityLog: "Activity Log",
      basicDetails: "Basic Details",
      supplierContacts: "Supplier Contacts",
      legalDocs: "Legal Documents",
      trn: "TRN/VAT Number",
    },
    validation: {
      englishNameRequired: "English Name is required",
      arabicNameRequired: "Arabic Name is required",
      supplierTypeRequired: "Supplier Type is required",
      trnVatNumberNumericOnly: "TRN / VAT Number must contain only numbers",
      trnVatNumberMaxDigits: "TRN / VAT Number must not exceed 15 digits",
      trnVatNumberLength: "TRN / VAT Number must not exceed 15 digits",
      fileSizeExceeded: "File size exceeds the maximum allowed size of 50 MB",
      duplicateFile:
        "Duplicate file detected. This file has already been added",
      phoneRequired: "Phone Number is required",
      phoneInvalid: "Phone Number must contain only numbers",
      phoneLength: "Phone Number must be exactly 10 digits",
      mobileFormatNotValid: "Mobile format is not valid",
      emailInvalid: "Please enter a valid email address",
      cityRequired: "City is required",
      addressRequired: "Address is required",
      contactPersonNameRequired: "Contact Person Name is required",
      contactPersonNameNotNumbersOnly:
        "Contact Person Name cannot be numbers only",
      noSpecialChars: "Special characters are not allowed",
      contactPersonDuplicate: "This contact person has already been added",
      contractTypeRequired: "Contract Type is required",
      startDateRequired: "Start Date is required",
      endDateRequired: "End Date is required",
      endDateAfterStart: "End Date must be after Start Date",
      contractDocumentsRequired:
        "At least one contract document is required for Fixed-Price Agreement",
      duplicateVariants:
        "Duplicate variants found. The same item cannot have multiple variants with the same unit, pack size, and price.",
      duplicateVariantsForItem:
        'Item "{{itemName}}" has duplicate variants with the same unit and pack size.',
      purchasePriceMustBeGreaterThanZero:
        "Purchase price must be greater than 0",
    },
    itemsAddedSuccessfully: "Items added successfully",
    addedSuccessfully: "Supplier added successfully",
    addedSuccessfullyDescription:
      "Your supplier is now available and ready to use.",
    updatedSuccessfully: "Supplier updated successfully",
    updatedSuccessfullyDescription:
      "Your supplier changes have been saved.",
    addItemsModal: {
      noItemsToAdd: "No items to add",
      title: "Add Items to Supplier",
      description:
        "Select items from one or more subcategories to set supplier pricing.",
      selectCategory: "Select Category",
      chooseItems: "Choose items to add",
      addedItems: "Added Items",
      addAllItems: "Add all items",
      removeAll: "Remove All",
      addItems: "Add Items",
      searchPlaceholder: "Search",
      noItemsFound: "No items found",
      allItemsAdded: "All Items are Added",
      addItemsPlaceholder: "Add items to appear here",
      itemsSelected: "{{count}} item/s Selected",
      itemsCount: "{{selected}}/{{total}}",
      itemsTotal: "{{count}} items",
    },
    addItemsTable: {
      baseUnit: "Base Unit",
      packSize: "Pack Size",
      purchasePrice: "Purchase Price",
      supplierRole: "Supplier Role",
      main: "Main",
      backup: "Backup",
    },
    addPricesToItems: "Food / Add Prices to Items",
    itemsSavedSuccessfully: "Items saved successfully",
    bulkActions: {
      selected: "Selected",
      applySameType: "Apply Same Type to Selected Items",
      applySamePrice: "Apply Same Price to Selected Items",
      apply: "Apply",
      deleteSelected: "Delete Selected",
      mixed: "Mixed",
      roleApplied: "Role applied successfully",
      priceApplied: "Price applied successfully",
      itemsDeleted: "Selected items deleted successfully",
    },
    addVariant: {
      title: "Add Purchase Variant",
      description: "Define a new unit and pack size for this item.",
      purchaseUnit: "Purchase Unit",
      selectUnit: "Select Unit (box, carton, sack, etc)",
      packSize: "Pack Size",
      packSizePlaceholder: "12kg per carton",
      purchasePrice: "Purchase Price",
      addAnother: "Add Another Variant",
      clearAll: "Clear All",
      addVariants: "Add Variant/s",
      addNewUnitSize: "Add New Unit/Size",
      selectUnitSize: "Select Unit / Size",
      duplicateError: "Duplicate entry",
      alreadyExistsError: "This variant already exists for this item",
      successToast: "Variants are added successfully",
      overrideTooltip: "You can override the purchase UOM and pack size.",
    },
    // Unsaved Changes Modals
    exitWithoutSaving: "Exit Without Saving?",
    unsavedChanges: "Unsaved Changes",
    formContainsUnsavedItems: "This form contains unsaved item details.",
    haventSavedItems: "You haven't saved added item and prices yet.",
    exitingWillDelete: "Exiting now will permanently delete all entered data.",
    goingBackWillRemove: "If you go back, all items and prices will be removed",
    discardAndExit: "Discard & Exit",
    discardChanges: "Discard Changes",
    saveDraft: "Save Draft",
    saveAndGoBack: "Save & Go Back",
    saveDraftModalTitle: "Draft Saved!",
    saveDraftModalSubTitle: "Your progress has been saved as a draft.",
    saveDraftModalDescription:
      "You can return later to continue editing the supplier details.",
    saveDraftModalCancel: "Exit Form",
    saveDraftModalConfirm: "Continue Editing",
    itemsAdded: "Items Added",
    submitSupplier: "Submit Supplier",
    saveSupplier: "Save Supplier",
    saveAsDraft: "Save as draft",
    errorBoundary: {
      title: "Something went wrong while loading the supplier form.",
      description:
        "Your changes may not have been saved. Please refresh and try again.",
      reload: "Reload page",
    },
  },

  // Purchase Orders
  purchaseOrders: {
    title: "Purchase Orders",
    poNumber: "PO Number",
    supplierName: "Supplier Name",
    orderType: "Order Type",
    expectedDeliveryDate: "Expected Delivery Date",
    actualDeliveryDate: "Actual Delivery Date",
    totalAmount: "Total Amount",
    orderStatus: "Order Status",
    supplier: "Supplier",
    creationDate: "Creation Date",
    status: {
      label: "Status",
      pending: "Pending",
      completed: "Completed",
      rejected: "Rejected",
      cancelled: "Cancelled",
      canceled: "Canceled",
      accepted: "Accepted",
      acceptedPartial: "Accepted Partial",
      completedCloseShort: "Completed Close Short",
    },
    orderTypes: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      custom: "Custom",
    },
    searchPlaceholder: "Search by PO Number or Supplier Name",
    selectSupplier: "Select Supplier",
    selectStatus: "Select Status",
    selectDate: "Select Specific Date",
    date: "Date",
    createOrder: "Create Order",
    results: "Results: {{count}} Orders",
    total: "Total: {{count}} Orders",
    exportSuccess: "Export completed. File downloaded successfully",
    emptyState: {
      title: "No Orders Created Yet.",
      message: "No Orders Created Yet.",
      createButton: "Create Order",
    },
    details: {
      title: "Purchase Order Details",
      mainTabs: {
        orderList: "Order List",
        infoNotes: "Info & Notes",
      },
      tabs: {
        orderInfo: "Order Info",
        supplier: "Supplier Details",
        notes: "Notes & Instructions",
      },
      orderInfo: {
        title: "Order Information",
        statusPending: "Pending",
        statusPendingMessage:
          "This purchase order is awaiting Receiving & QC confirmation.",
        statusCancelled: "Cancelled",
        statusCancelledMessage:
          "This purchase order was cancelled and will not proceed to receiving.",
        statusRejected: "Rejected",
        statusRejectedMessage:
          "This purchase order has been rejected and was not approved for processing.",
        statusCompleted: "Completed",
        statusCompletedMessage:
          "This purchase order has been received and approved by Receiving & QC.",
        statusCompletedShort: "Completed (Closed Short)",
        statusCompletedShortMessage:
          "This purchase order has been closed with some items not fully received.",
        createdOn: "Created On",
        createdBy: "Created By",
        expectedDeliveryDate: "Expected Delivery Date",
        orderType: "Order Type",
        customOrderDate: "Custom Date",
        reasonForRejection: "Reason for rejection:",
        rejectedBy: "Rejected By",
        actualDeliveryDate: "Actual Delivery Date",
        receivedBy: "Received By",
      },
      supplier: {
        contractDetails: "Contract Details",
        type: "Type",
        date: "Date",
        supplierContacts: "Supplier Contacts",
        phoneNumber: "Phone Number",
        email: "Email",
        address: "Address",
        contactPerson: "Contact Person",
      },
      notes: {
        internalNotes: "Internal Notes",
        forSupplier: "For Supplier",
        documents: "Documents",
      },
      orderList: {
        title: "Order Summary",
        itemName: "Item Name",
        sku: "SKU",
        purchaseUOM: "Purchase UOM",
        packSize: "Pack Size",
        purchasePrice: "Purchase Price",
        quantity: "Quantity",
        lineSubtotal: "Line Subtotal",
        finalSubtotal: "Final Subtotal",
        ordered: "Ordered",
        originalSubtotal: "Original Subtotal",
        accepted: "Accepted",
        orderBreakdown: "Order Breakdown",
        delivered: "Delivered",
        remaining: "Remaining",
        rejected: "Rejected",
        status: "Status",
        rejectionReason: "Rejection Reason",
        viewReason: "View Reason",
        rejectionDetails: "Rejection Details",
        rejectedItemsCount: "{{count}} Rejected",
      },

      financial: {
        paymentDetails: "Payment Summary",
        title: "Order Price Details",
        priceBeforeVAT: "Price Before VAT",
        discount: "Discount",
        subtotal: "Subtotal",
        deliveryFees: "Delivery Fees",
        vat: "VAT",
        grandTotal: "Grand Total",
        finalSettledAmount: "Final Settled Amount",
        originalPayment: "Original Payment",
        finalPayment: "Final Payment",
        originalPOAmount: "Original PO Amount",
      },
      actions: {
        cancel: "Cancel",
        exportPdf: "Export PDF",
        reOrder: "Re-Order",
        startReceiving: "Start Receiving",
      },
      cancelModal: {
        title: "Cancel Order ?",
        message:
          "Cancelling this order will stop it from proceeding to receiving.",
        warning: "This action can't be undone.",
        keepOrder: "Keep Order",
        continueToCancel: "Continue to Cancel",
      },
      cancelSuccess: {
        title: "Order Canceled",
        message: "The order will not proceed to receiving.",
      },
    },
    create: {
      title: "Create Purchase Order",
      step1Title: "Step 1",
      step1Subtitle: "Select Supplier",
      step1Description: "Select the supplier you want to order from",
      step1ProgressTitle: "Select the supplier you want to order from",
      step2Title: "Step 2",
      step2Subtitle: "Add Items",
      step2Description: "Add items to your order",
      step2ProgressTitle: "Add items to your purchase order",
      step3Title: "Step 3",
      step3Subtitle: "Order Details",
      step3Description: "Review and submit your order",
      step3ProgressTitle: "Review order details and submit",
      selectSupplier: "Select Supplier",
      searchSupplier: "Search",
      supplierDetails: "Supplier Details",
      currency: "Currency",
      contractDetails: "Contract Details",
      type: "Type",
      date: "Date",
      submit: "Submit Order",
      noSpecifiedDate: "No specified date",
      purchaseVariant: "Purchase Variant",
      sideCardDesc1:
        "Any added purchase variant will be saved for future use with this supplier.",
      purchasePrice: "Purchase Price",
      sideCardDesc2:
        "Changes to the predefined purchase prices will affect this PO only, unless set as default.",
    },
    orderSummary: {
      orderSummary: "Order Summary",
      editItems: "Edit items",
      paymentSummary: "Payment Summary",
      priceBeforeVat: "Price Before VAT",
      deliveryFees: "Delivery Fees",
      grandTotal: "Grand Total",
      subtotal: "Subtotal",
      discount: "Discount",
      vat: "VAT",
    },
    export: {
      poNumber: "PO Number",
      supplierName: "Supplier Name",
      orderType: "Order Type",
      expectedDeliveryDate: "Expected Delivery Date",
      totalAmount: "Total Amount",
      status: "Status",
      creationDate: "Creation Date",
    },
    additionalDetails: {
      additionalDetails: "Additional Details",
      delivery: "Delivery",
      expectedDeliveryDate: "Expected Delivery Date",
      internalNotes: "Internal Notes",
      addNotes: "Add Notes",
      internalNotesPlaceholder: "Add any internal notes here…",
      forSupplier: "For Supplier",
      notesInstructions: "Notes / Instructions",
      supplierNotesPlaceholder: "Add notes or instructions for the supplier…",
      selectOrderType: "Select Order Type",
      orderTypeHelper:
        "Helps in scheduling reminders and tracking the next order.",
      orderType: "Order Type",
      nextOrderDate: "Select Next Order Date",
      orderDiscount: "Order Discount",
      discountValue: "Discount Value",
      discountPercentage: "Discount Percentage",
      discountApplied: "Discount Applied",
      applyDiscount: "Apply Discount",
      uploadDocument: "Upload Document",
      chooseFile: "Choose File",
      dropFilesHere: "Drop files here to upload",
      formatsHint: "Formats: PDF, JPG, PNG.",
      invalidFormat: "Invalid format. Allowed: PDF, JPG, PNG.",
      discountMustBeLessThan100:
        "Discount percentage must be less than or equal to 100",
      discountMustBeGreaterThan0: "Discount value must be greater than 0",
      discountMustBeLessThanSubtotal:
        "Discount value must be less than the subtotal",
    },
    addItemsModal: {
      title: "Add Items to Order",
      description: "Select items from the supplier’s category",
    },
    addItemsTable: {
      quantity: "Quantity",
      discount: "Discount",
      subtotal: "Subtotal",
      noItems: "No Items Added Yet",
      beforeDiscount: "Before Discount",
      allItemsDeleted: "All Items have been Removed.",
      itemDeleted: "{{name}} has been Removed.",
      items: "Items",
      value: "Value",
      setAsDefault: "Set as Default",
      setAsDefaultTooltip: "Use this Updated Price for future POs.",
      clearDefault: "Clear Default",
      clearDefaultTooltip: "Apply this price change to this PO only.",
      itemsAddedSuccessfully: "{{count}} Item/s added successfully",
      discountPercentageError: "Discount percentage should not exceed 100%",
      discountValueError: "Discount value should not exceed the item subtotal",
      maxPurchasePriceError:
        "Maximum purchase price can't be greater than '99999'",
    },
    orderCreated: "Order created successfully",
    orderCreatedDesc:
      "Your order has been saved and is ready for the next step.",
    exitTitle: "Exit Without Saving?",
    exitSubtitle: "This form contains unsaved item details.",
    exitDesc: "Exiting now will permanently delete all entered data.",
    setAsDefaultTitle:
      "Are you sure you want to set {{price}} purchase price as the default for {{item}}?",
    setAsDefaultDesc:
      "Changes in purchase price will now apply to all future POs unless changed.",
    setAsDefaultCancel: "No, Cancel",
    setAsDefaultConfim: "Yes, set as default",
    clearDefaultTitle:
      "Are you sure you want to clear the default and make the updated price one-time use only?",
    clearDefaultDesc:
      "The updated purchase price will apply to this order only and not future POs.",
    clearDefaultCancel: "No, Cancel",
    clearDefaultConfim: "Yes, clear default",
    saveDraftModalTitle: "Draft Saved!",
    saveDraftModalSubTitle: "Your progress has been saved as a draft.",
    saveDraftModalDescription:
      "You can return later to continue editing the order details.",
    saveDraftModalCancel: "Exit Form",
    saveDraftModalConfirm: "Continue Editing",
    draftModalTitle: "You have unfinished purchase order",
    draftModalSubTitle: "You started creating an order but didn’t finish it.",
    draftModalDescription: "Complete the existing draft or create new order.",
    draftModalCancel: "Create New Order",
    draftModalConfirm: "Complete Form",
    createConfirmationModalTitle: "Confirm Purchase Order",
    createConfirmationModalSubTitle:
      "Are you sure you want to submit this purchase order?",
    createConfirmationModalDescription:
      "Once submitted, the purchase order will move to Pending status and will become available for receiving.",
    createConfirmationModalCancel: "No, Keep Editing",
    createConfirmationModalConfirm: "Yes, Submit Order",
    purchaseOrderDetails: "Order Details",
  },

  // Receiving & QC
  receivingQc: {
    title: "Pending Purchase Orders",
    startReceiving: "Start Receiving",
    receiveOrder: "Receive Order",
    noPendingOrders: "No Pending Purchase Orders available for Receiving.",
    noPOMatchYourFilter: "No Purchase Order Match Your Filter",
    overdue: "Overdue",
    deliveryDateFilter: "Filter Delivery Date",
    creationDateFilter: "Filter Creation Date",
    createOrder: {
      title: "Create Receiving Order",
    },
    stepper: {
      step1Title: "Step 1",
      step1Subtitle: "Receive Items",
      step1ProgressTitle:
        "Enter delivered and accepted quantities for each item",
      step2Title: "Step 2",
      step2Subtitle: "Review & Submit",
      step2ProgressTitle: "Review order and confirm submission",
    },
    step1: {
      itemName: "Item Name",
      ordered: "Ordered",
      delivered: "Delivered",
      accepted: "Accepted",
      rejected: "Rejected",
      remaining: "Remaining",
      rejectionReason: "Rejection Reason",
      viewEditReason: "View/Edit Reason",
      all: "All",
      partial: "Partial",
    },
    step2: {
      expectedDeliveryDate: "Expected Delivery Date",
      actualDeliveryDate: "Actual Delivery Date",
      reviewItems: "Review Items",
      paymentSummary: "Payment Summary",
      totalAmount: "Total Amount",
    },
    footer: {
      fullyAccepted: "Fully Accepted",
      partiallyAccepted: "Partially Accepted",
      fullyRejected: "Fully Rejected",
      fullyMissed: "Fully Missed",
      reviewSubmit: "Review & Submit",
      submit: "Submit",
      rejectOrder: "Reject Order",
    },
    modals: {
      addRejectionReason: "Add Rejection Reason",
      editRejectionReason: "Edit Rejection Reason",
      addRejectionReasonDescription:
        "Please specify the reason for rejecting the following item(s)",
      rejectionReasonLabel: "Rejection Reason",
      rejectionReasonPlaceholder: "Add Reason Here...",
      uploadDocuments: "Upload Documents",
      formatsHint: "Formats: PDF, JPG, PNG.",
      submitReason: "Submit Reason",
      updateReason: "Update Reason",
      rejectOrderTitle: "Are you sure you want to reject this order?",
      rejectOrderSubtitle: "This action will reject the entire order.",
      addRejectionReasonLabel: "If yes, add rejection reason",
      yesRejectOrder: "Yes, Reject Order",
      orderRejected: "Order Rejected",
      orderRejectedDesc: "All items have been marked as rejected.",
      confirmSubmitTitle: "Confirm Receiving Submission",
      confirmSubmitSubtitle:
        "Are you sure you want to submit this receiving form?",
      confirmSubmitDesc:
        "Once submitted, the received and rejected quantities will be recorded and the purchase order will be updated accordingly.",
      keepEditing: "No, Keep Editing",
      confirmReceipt: "Yes, Confirm Receipt",
      receivingSuccess: "Receiving Completed successfully",
      receivingSuccessDesc: "PO Status and inventory has been updated.",
    },
    badges: {
      accepted: "Accepted",
      remaining: "Remaining",
      fullyMissed: "Fully Missed",
      fullyRejected: "Fully Rejected",
      rejected: "Rejected",
    },
  },

  transfers: {
    title: "Transfers",
    incomingTransfers: "Incoming Transfers",
    outgoingTransfers: "Outgoing Transfers",
    createTransfer: "Create Transfer",
    searchPlaceholder: "Search by Transfer #",
    selectLocation: "Select Location",
    selectStatus: "Select Status",
    total: "Total: {{count}} Transfers",
    noTransfers: "No transfers have been made yet.",
    noResultsFound: "No Transfers Match Your Filter",
    dateFilter: "Creation Date Filter",
    deliveryDateFilter: "Filter Delivery Date",
    deliveryDate: {
      filter: "Filter Delivery Date",
      today: "Today",
      yesterday: "Yesterday",
      customRange: "Custom Range",
    },
    applyMultipleFilters: "Apply multiple filters to narrow down your results.",
    table: {
      transferNumber: "Transfer #",
      source: "Source",
      destination: "Destination",
      createdOn: "Created On",
      deliveryDate: "Delivery Date",
      itemCount: "Item Count",
      status: "Status",
      actions: "Actions",
      totalAmount: "Total Amount",
    },
    status: {
      pendingReceiving: "Pending Receiving",
      completed: "Completed",
      partiallyAccepted: "Partially Accepted",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },
    details: {
      mainTabs: {
        transferList: "Transfer List",
        infoLog: "Transfer Info & Log",
      },
      actions: {
        cancel: "Cancel",
        reject: "Reject Transfer",
        startReceiving: "Start Receiving",
      },
      transferList: {
        summaryTitle: "Transfer Summary",
        breakdownTitle: "Transfer Breakdown",
        itemName: "Item Name",
        transferQty: "Transfer Qty",
        acceptedQty: "Accepted Qty",
        totalBaseQty: "Total Base Qty",
        stockValue: "Stock Value",
        baseAcc: "Base ACC",
        transferAmount: "Transfer Amount",
        finalStockValue: "Final Stock Value",
        finalTransferAmount: "Final Transfer Amount",
        sent: "Sent",
        rejected: "Rejected",
        remaining: "Remaining",
        status: "Status",
        rejectionReason: "Rejection Reason",
        viewReason: "View Reason",
        rejectionDetails: "Rejection Details",
        rejectedItemsCount: "{{count}} Rejected",
      },
      financial: {
        title: "Financial Summary",
        itemsCount: "{{count}} Items",
        totalStockValue: "Total Stock Value",
        sentValue: "Sent Value",
        remainingValue: "Remaining Value",
        totalAcceptedValue: "Total Accepted Value",
        totalTransferAmount: "Total Transfer Amount",
      },
      tabs: {
        transferInfo: "Transfer Info",
        destinationInfo: "Destination Location Info",
        activityLog: "Activity Log",
      },
      transferInfo: {
        createdOn: "Created On",
        createdBy: "Created By",
        receivedBy: "Received By",
        deliveryDate: "Delivery Date",
        transferType: "Transfer Type",
        statusPending: "Pending Receiving",
        statusPendingMessage:
          "This transfer is awaiting Receiving confirmation from the destination location.",
        statusCompleted: "Completed",
        statusCompletedMessage:
          "This transfer has been fully received and completed.",
        statusPartiallyAccepted: "Partially Accepted",
        statusPartiallyAcceptedMessage:
          "This transfer has been partially received and accepted.",
        statusCancelled: "Cancelled",
        statusCancelledMessage:
          "This transfer was cancelled and will not proceed to receiving.",
        statusRejected: "Rejected",
        statusRejectedMessage:
          "This transfer has been rejected and was not approved for processing.",
        reasonForRejection: "Reason for rejection:",
      },
      transferTypes: {
        ck_to_branch: "CK → Branch",
        branch_to_branch: "Branch → Branch",
      },
      destination: {
        title: "Destination",
        contactDetails: "Contact Details",
        phoneNumber: "Phone Number",
        email: "Email",
        address: "Address",
      },
      cancelModal: {
        title: "Cancel Transfer",
        message: "Are you sure you want to cancel this transfer?",
        warning: "This action cannot be undone.",
        keepTransfer: "Keep Transfer",
        continueToCancel: "Continue to Cancel",
      },
      rejectModal: {
        title: "Are you sure you want to reject this Transfer?",
        message: "This action will reject the entire transfer.",
        reasonLabel: "If yes, add rejection reason",
        reasonPlaceholder: "Add reason here..",
        confirm: "Yes, Reject Transfer",
      },
      rejectSuccess: {
        title: "Transfer Rejected",
        message: "All items have been marked as rejected.",
      },
    },
  },

  incomingRequests: {
    btn :"btn",
    title: "Incoming Requests",
    searchPlaceholder: "Search by Request number",
    selectLocation: "Select Location",
    selectCreationDate: "Select Creation Date",
    locationSelected: "{{location}} Selected",
    total: "Total: {{count}} Requests",
    noRequestsMatchYourFilter: "No Requests Match Your Filter",
    emptyState: {
      title: "No Requests Sent Yet",
    },
    table: {
      requestNumber: "Request #",
      requestedBy: "Requested by",
      creationDate: "Creation Date",
      itemCount: "Item Count",
      actions: "Actions",
    },
    details: {
      requestInfo: "Request Info",
      requestedItems: "Requested Items",
      itemsCount: "{{count}} Items",
      sentOn: "Sent On",
      sentBy: "Sent By",
      makeTransfer: "Make Transfer",
      transfer: "Transfer",
      itemName: "Item Name",
      requestedQty: "Requested Qty",
      availableStock: "Available Stock",
      availabilityStatus: "Availability Status",
      status: {
        pending: "Pending",
        pendingMessage:
          "Waiting for the central kitchen to review and fulfill this transfer request.",
        pendingReceiving: "Pending Receiving",
        pendingReceivingMessage:
          "This request has been sent and is awaiting receipt at the destination branch.",
        completed: "Completed",
        completedMessage: "This request has been fully fulfilled and closed.",
        partiallyAccepted: "Partially Accepted",
        partiallyAcceptedMessage:
          "Some items were fulfilled while others are still pending.",
      },
    },
    status: {
      available: "Available",
      notEnough: "Not Enough",
      outOfStock: "Out of Stock",
    },
    sendItems: {
      pageTitle: "Send All Items to Branches / {{date}}",
      step: {
        title: "Final Step",
        subtitle: "Review & Confirm",
        content: "Review the quantities before sending.",
      },
      reviewTitle: "Review Item Confirmed Quantities",
      scrollHint: "Scroll horizontally to see all branches.",
      footer: {
        summary: "{{itemTypes}} Item Types - {{branches}} Branches",
        sendItems: "Send Items",
      },
      table: {
        itemNameAndTotals: "Item Name + Total Quantities",
        branchColumn: "{{name}} ({{count}})",
        requested: "Requested",
        confirmed: "Confirmed",
        ckStock: "CK Stock",
        toPrepare: "To Prepare",
      },
      confirmModal: {
        title: "Send Items to Branches?",
        description:
          "The quantities being sent will be deducted from CK inventory, and the items will be marked as sent to the branches.",
        cancel: "Cancel",
        confirm: "Confirm & Send",
      },
      successModal: {
        title: "Items sent successfully",
        description:
          "Your items have been sent and your inventory is updated.",
      },
    },
    startPreparation: {
      pageTitle: "Send All Items to Branches",
      step1: {
        title: "Step 1",
        subtitle: "Check Stock & Qty",
        content: "Check & edit each quantity to adjust each request.",
      },
      step2: {
        title: "Step 2",
        subtitle: "Review & Confirm",
        content: "Confirm the quantities before sending.",
      },
      infoCard: {
        title: "Preparation",
        description:
          "Lower quantities will be sent to branches; remaining will be prepared.",
      },
      checkStockTitle: "Check & edit each quantity to adjust each request",
      reviewTitle: "Review Transfer Quantities",
      scrollHint: "Scroll horizontally to see all {{count}} branches.",
      footer: {
        summary: "{{itemTypes}} Item Types - {{branches}} Branches",
        confirmQuantities: "Confirm Quantities",
      },
      reviewTable: {
        itemName: "Item Name",
        sku: "SKU",
        requestedQty: "Requested Qty",
        confirmedQty: "Confirmed Qty",
        availableStock: "Available Stock",
        qtyToPrepare: "Qty to Prepare",
      },
      table: {
        itemNameAndTotals: "Item Name + Total Quantities",
        branchColumn: "{{name}} ({{count}})",
        requested: "Requested",
        confirmed: "Confirmed",
        ckStock: "CK Stock",
        toPrepare: "To Prepare",
      },
      drawer: {
        title: "Edit Confirmed Quantities",
        itemSku: "{{name}} - {{sku}}",
        totalRequested: "Total Requested",
        totalConfirmed: "Total Confirmed",
        ckAvailableStock: "CK Available Stock",
        qtyToPrepare: "Qty to Prepare",
        requestedQty: "Requested Qty",
        confirmedQty: "Confirmed Qty",
        save: "Save Quantities",
        previousItem: "Previous item",
        nextItem: "Next item",
        qtyUpdated: "\"{{name}}\" Confirmed qty have been updated",
        errors: {
          required: "Confirmed qty is required",
          zeroOrNegative: "Quantity can't be negative",
          invalid: "Enter a valid quantity",
          exceedsRequested: "Cannot exceed requested quantity",
          tooLong: "Quantity cannot exceed 10 digits",
          integerOnly: "This unit does not allow decimals",
        },
      },
      confirmModal: {
        title: "Confirm quantities for {{date}}?",
        description:
          "Once stock covers every item’s confirmed quantity, the status will change to Prepared and Send Items will become available.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Confirm Quantities",
      },
      readyToSendModal: {
        title: "All items are ready to send",
        description:
          "Available stock covers all confirmed quantities. You can send the items directly to the branches without additional preparation.",
        keepEditing: "Keep Editing",
        sendItemsNow: "Send Items Now",
      },
    },
  },

  // Prepared Item Requests (CK)
  preparedItemRequests: {
    title: "Prepared Item Requests",
    reviewPreparationPlan: "Review Preparation Plan",
    sendItems: "Send Items",
    viewAggregatedItems: "View Aggregated Items",
    totalRequests: "Total: {{count}} Requests",
    totalPreparedItems: "Total: {{count}} Prepared Items",
    infoTooltip: {
      label: "Information about preparation dates",
      title: "Preparation Date Grouping",
      description:
        "Each preparation date groups requests received by CK before its cutoff. Later requests move to the next preparation date. Select a date to view its cycle. Review Preparation Plan becomes available after cutoff and applies to all requests in that cycle.",
    },
    tabs: {
      branchRequests: "Branch Requests",
      aggregatedItem: "Aggregated Item",
    },
    emptyState: {
      noRequestsSentYet: "No Requests Sent Yet",
      noResultsFound: "No results match your filters",
      noItemsForDate: "No prepared items for this date",
      selectPreparationDate: "Select a preparation date to view aggregated items",
      loadError: "Unable to load prepared item requests. Please try again.",
      retry: "Try again",
    },
    filters: {
      searchPlaceholder: "Search by request number, branch, or prepared item",
      aggregatedSearchPlaceholder: "Search by prepared item name or SKU",
      selectSubmissionDate: "Select Submission Date",
      selectPreparationDate: "Select Preparation Date",
      preparationPlanDate: "Preparation Plan Date",
      selectRequestingBranch: "Select Requesting Branch",
      branchSelected: "{{branch}} Selected",
      requestStatusAll: "Request Status: All",
      requestStatusWithValue: "Request Status: {{status}}",
      statusAll: "Status: All",
      statusPending: "Pending",
      statusCompleted: "Completed",
    },
    table: {
      requestNumber: "Request #",
      requestedBy: "Requested by",
      submissionDate: "Submission Date",
      preparationDate: "Preparation Date",
      preparedItems: "Prepared Items",
      totalAmount: "Total Amount",
      requestStatus: "Request Status",
      actions: "Actions",
    },
    aggregatedTable: {
      preparedItemName: "Prepared Item Name",
      sku: "SKU",
      totalRequestedQty: "Total Requested Qty",
      totalConfirmedQty: "Total Confirmed Qty",
      ckAvailableStock: "CK Available Stock",
      qtyToPrepare: "Qty to Prepare",
      requestingBranches: "Requesting Branches",
    },
    plans: {
      title: "Preparation Plans",
      subtitle: "Choose a preparation day to see its pending requests.",
      todaysPlan: "Today's Plan",
      todaysPlanDescription: "Pending requests assigned to today",
      nextPreparation: "Next Preparation",
      nextPreparationDescription: "Requests submitted after today's cutoff",
      allRequests: "All Requests",
      allRequestsDescription: "See all requests regardless of preparation date.",
      requestCountLabel: "Requests",
    },
    summary: {
      todaysPreparation: "Today's Preparation",
      nextPreparation: "Next Preparation",
      allRequests: "All Requests",
      requestsInPlan: "Requests In Plan",
      branches: "{{count}} Branches",
      preparationDate: "Preparation Date",
      requestCutoff: "Request Cutoff",
      timeLeft: "{{time}} left",
      preparationStatus: "Preparation Status",
      totalPreparedItems: "Total Prepared Items",
      items: "items",
      allRequestsDescription: "View all branch requests across preparation dates..",
    },
    status: {
      pending: "Pending",
      awaitingReview: "Awaiting Review",
      beingPrepared: "Being Prepared",
      prepared: "Prepared",
      sent: "Sent",
      completed: "Completed",
      completedClosedShort: "Completed (Closed Short)",
      rejected: "Rejected",
    },
    details: {
      title: "Request Details",
      aggregatedTitle: "Aggregated Item Details",
      requestInfo: "Request Info",
      preparationInfo: "Preparation Info",
      requestedItems: "Requested Items",
      itemTypes: "{{count}} Item Types",
      itemsCount: "{{count}} Items",
      totalRequests: "Total Requests",
      requestingBranches: "Requesting Branches",
      requestsCount: "{{count}} Requests",
      sentStatusMessage:
        "Sending is complete. The sent quantities have been deducted from CK inventory.",
      preparedItemName: "Prepared Item Name",
      requestedQty: "Requested Qty",
      requestedAmount: "Requested Amount",
      confirmedQty: "Confirmed Qty",
      confirmedAmount: "Confirmed Amount",
      sentQty: "Sent Qty",
      sentAmount: "Sent Amount",
      createdOn: "Created On",
      submittedOn: "Submitted On",
      createdBy: "Created By",
      preparationStatus: "Preparation Status",
      preparationStartedOn: "Preparation Started On",
      preparationStartedBy: "Preparation Started By",
      confirmQuantitiesOn: "Confirm Quantities On",
      confirmQuantitiesBy: "Confirm Quantities By",
      markedPreparedOn: "Marked Prepared On",
      markedPreparedBy: "Marked Prepared By",
      sentOn: "Sent On",
      sentBy: "Sent By",
      rejectedOn: "Rejected On",
      rejectedBy: "Rejected By",
      reasonForRejection: "Reason for rejection",
      financialSummary: "Financial Summary",
      totalRequestedValue: "Total Requested Value",
      shortValue: "Short Value",
      totalSentAmount: "Total Sent Amount",
      totalReceivedAmount: "Total Received Amount",
      reject: "Reject",
      requestingBranch: "Requesting Branch",
      rejectModal: {
        title: "Are you sure you want to reject this request?",
        message: "This action will reject the entire request.",
        reasonLabel: "If yes, add rejection reason",
        reasonPlaceholder: "Add Reason Here...",
        confirm: "Yes, Reject Request",
      },
    },
    banner: {
      preparationActionsApply:
        "Preparation actions apply to all requests for {{date}}, including filtered-out requests.",
    },
    planNotice: {
      todayClosedBold: "Today's plan is closed for new requests.",
      todayOpenBold: "Today's plan is open for new requests.",
      todayClosedDetail:
        "Requests submitted after {{time}} will be included in the next preparation date.",
      nextScheduledBold: "These requests are scheduled for {{date}}.",
      nextScheduledDetail:
        "They are not included in today's preparation plan.",
    },
  },

  requestsSent: {
    title: "Prepared Items Requests",
    createRequest: "Create Request",
    emptyState: {
      title: "No Requests Created Yet",
    },
    total: "Total: {{count}} Requests",
    itemsCount: "{{count}} items",
    datePlaceholder: "DD/MM/YYYY",
    selectStatus: "Select Status",
    statusSelected: "Status: {{status}}",
    searchPlaceholder: "Search by Request number",
    selectCreationDate: "Select Creation Date",
    table: {
      requestNumber: "Request #",
      creationDate: "Creation Date",
      preparedItems: "Prepared Items",
      preparationDate: "Preparation Date",
      totalAmount: "Total Amount",
      status: "Status",
      actions: "Actions",
    },
    details: {
      title: "Request Details",
      requestInfo: "Request Info",
      requestedItems: "Requested Items",
      itemTypes: "{{count}} Item Types",
      preparedItemName: "Prepared Item Name",
      requestedQty: "Requested Qty",
      requestedAmount: "Requested Amount",
      receivedQty: "Received Qty",
      receivedAmount: "Received Amount",
      shortQty: "Short Qty",
      shortAmount: "Short Amount",
      createdOn: "Created On",
      createdBy: "Created By",
      receivedOn: "Received On",
      receivedOnHint:
        "Received On shows when Central Kitchen completed sending the items. It does not confirm physical receipt at your branch.",
      editedOn: "Edited On",
      editedBy: "Edited By",
      rejectedOn: "Rejected On",
      rejectedBy: "Rejected By",
      rejectReason: "Reason for rejection",
      cancelledOn: "Cancelled On",
      cancelledBy: "Cancelled By",
      financialSummary: "Financial Summary",
      totalRequestedValue: "Total Requested Value",
      shortValue: "Short Value",
      vat: "VAT",
      totalReceivedAmount: "Total Received Amount",
      timeWindowClosed: "Time window closed",
      timeWindowCloses: "Time window closes",
      timeLeftToEditCancel: "Time left to edit/cancel",
      cancelModal: {
        title: "Cancel Request ?",
        message:
          "Cancelling this request will stop it from proceeding to preparation.",
        warning: "This action can't be undone.",
        keepRequest: "Keep Request",
        continueToCancel: "Continue to Cancel",
      },
    },
  },

  createPreparedRequest: {
    title: "Request Prepared Item",
    editTitle: "Edit Prepared Item Request",
    step1Title: "Step 1",
    step1Subtitle: "Add items",
    step1Content: "Add the items you want to request.",
    step2Title: "Step 2",
    step2Subtitle: "Review & Confirm",
    step2Content: "Review all entries and confirm to send request.",
    step1SectionTitle: "Add Required Quantities",
    step2SectionTitle: "Review Prepared Item Request",
    addPreparedItems: "Add Prepared Items",
    addItemsModal: {
      title: "Add Prepared Items to Request",
      description: "Select items from one or more categories.",
    },
    emptyState: {
      title: "No Items Added Yet",
    },
    table: {
      itemName: "Item Name",
      sku: "SKU",
      availableStock: "Available Stock",
      enteredQty: "Entered Qty",
      actions: "Actions",
      qtyPlaceholder: "Add Required Quantity",
    },
    qtyErrors: {
      required: "Quantity is required",
      zeroOrNegative: "Quantity must be greater than zero",
      invalid: "Invalid quantity",
    },
    review: {
      outputUom: "Output UOM",
      requestedQty: "Requested Qty",
    },
    footer: {
      itemTypesAdded: "{{count}} Item Types Added",
      submit: "Request Prepared Item",
      update: "Save Changes",
    },
    confirmModal: {
      title: "Submit request?",
      description:
        "Your request will be sent to Central Kitchen. No stock movement will be applied at this stage.",
      cancel: "Cancel",
      confirm: "Submit Request",
    },
    editConfirmModal: {
      title: "Update request?",
      description:
        "The updated quantities will be sent to Central Kitchen. No stock movement will be applied at this stage.",
      confirm: "Update Request",
    },
    successModal: {
      title: "Request Submitted Successfully",
      description:
        "Your request has been sent to Central Kitchen. No stock movement has been applied at this stage.",
      backToDashboard: "Back to Dashboard",
      viewRequest: "View Request",
    },
  },

  //inventory
  inventory: {
    setOpenningBalance: "Set Opening Balance",
    itemStockDetails: "Item Stock Details",
    totalStockValue: "Total Stock Value",
    liveInventory: "Live Inventory",
    viewOpeningBalance: "View Opening Balance",
    totalItems: "Total Items",
    totalItemsCount: "Total: {{count}} Items",
    acrossAllCategories: "Across all categories",
    aboveLevel: "Above Level",
    atLevel: "At Level",
    belowLevel: "Below Level",
    outOfStock: "Out of stock",
    itemsReorderNeeded: "Items (reorder needed)",
    searchPlaceholder: "Search by name, SKU, ...",
    selectCategory: "Select Category",
    selectSubcategory: "Select Subcategory",
    categorySelected: "{{category}} Selected",
    subcategorySelectedSingle: "{{count}} Subcategory Selected",
    subcategorySelectedMultiple: "{{count}} Subcategories Selected",
    export: {
      itemName: "Item name",
      sku: "SKU",
      category: "Category",
      subcategory: "Subcategory",
      currentQty: "Current qty",
      baseUnit: "Base unit",
      baseAcc: "Base ACC",
      stockValue: "Stock value",
      lastMovementDate: "Last movement date",
      lastMovementType: "Last movement type",
      lastMovementQty: "Last movement qty",
      parLevel: "Par level",
      barLevelStatus: "Bar level status",
    },
    sortBy: "Sort by",
    sortItemNameAsc: "Item Name (A-Z)",
    sortItemNameDesc: "Item Name (Z-A)",
    sortQtyAsc: "Current Qty (Low-High)",
    sortQtyDesc: "Current Qty (High-Low)",
    sortValueAsc: "Stock Value (Low-High)",
    sortValueDesc: "Stock Value (High-Low)",
    sortLastMovementAsc: "Last Movement (Oldest)",
    sortLastMovementDesc: "Last Movement (Newest)",
    itemName: "Item Name",
    currentQty: "Current Qty (Base Unit)",
    baseAcc: "Base ACC",
    stockValue: "Stock Value",
    lastMovementDate: "Last Movement Date",
    parLevel: "Par Level",
    barLevelStatus: "Bar Level Status",
    emptyTitle: "No inventory data yet",
    emptyDescription:
      "Start by recording your Opening Balance. This one-time setup establishes your current stock quantities and costs.",
    noResultsTitle: "No Results Found",
    noResultsDescription: "Try adjusting your search or filters.",
    openingBalanceTitle: "Opening Balance",
    reviewStockDetails: "Review Stock Details",
    exportOpeningBalancePdf: "Export PDF",
    obEnteredBaseQty: "Entered Base Qty",
    obUnitCost: "Unit Cost",
    obColPurchaseUomPack: "Purchase UOM / Pack Size",
    obColEnteredQty: "Entered Qty",
    obColPurchaseCost: "Purchase Cost",
    obColTotalBaseQty: "Total Base Qty",
    obColBaseUnitCost: "Base Unit Cost",
    stockSummary: "Stock Summary",
    expandAll: "Expand All",
    collapseAll: "Collapse All",
    baseUnitEntry: "By Base Unit",
    purchaseUnitEntry: "By Purchase Unit",
    lastMovement: "Last movement",
    lastMovementWasGain: "Last movement was a gain",
    lastMovementWasReduction: "Last movement was a reduction",
    receiving: "Receiving",
    transferToBranch: "Transfer to branch",
    change: "Change",
    currency: "AED",
    items: "Items",
    movementHistory: "Movement History",
    currentStock: "Current Stock",
    avgCurrentCost: "AVG Current Cost (ACC)",
    kilogramsUnit: "Kilograms ({{unit}})",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    selectMovementType: "Select movement type",
    gain: " + Gain",
    reduction: " - Reduction",
    positiveAdjustment: "Positive Adjustment",
    negativeAdjustment: "Negative Adjustment",
    batchOutput: "Batch Output",
    batchInput: "Batch Input",
    itemStockDetailsTable: {
      totalMovements: "Total: {{count}} Movements",
      movementDate: "Movement Date",
      type: "Type",
      quantityImpact: "Quantity Impact",
      resultedBalance: "Resulted Balance",
      accAtMoment: "ACC At Moment",
      reason: "Reason",
      reasonDetailsTitle: "Reason Details",
    },
    create: {
      title: "Opening Balance",
      step1Title: "Step 1",
      step1Subtitle: "Set Opening Stock",
      step1Content: "Add quantities and costs to set your initial stock",
      step2Title: "Step 2",
      step2Subtitle: "Review & Confirm",
      review_submit: "Review & Submit",
      totalStockValue: "Total Stock Value",
      itemsAdded: "Total Items",
      selectItem: "Select Item",
      categoryFilter: "Filter by Category",
      searchPlaceholder: "Search items or SKU",
      table: {
        itemName: "Item Name",
        sku: "SKU",
        totalQty: "Total Qty",
        baseACC: "Base ACC",
        openingStockValue: "Opening Stock Value",
        purchaseUnits: "Purchase Units",
        viewEdit: "View/Edit",
      },
      sidePanel: {
        setOpeningStock: "Set Opening Stock",
        resetAll: "Reset All",
        looseBaseQuantity: "Loose / Base Quantity",
        purchaseUnitEntry: "Purchase Unit Entry",
        stockBoughtOrStoredInBaseUnitDirectly:
          "Stock bought or stored in {{baseUOM}} directly.",
        PurchaseUnitsQuantity: "Purchase Units Quantity",
        stockBoughtOrStoredInPurchaseUnitDirectly:
          "Stock received and counted by purchase unit.",
        AddAnotherPurchaseUnit: "Add Another Purchase Unit",
        NoMorePurchaseUnitsAvailable: "No more purchase units available",
        cancel: "Cancel",
        saveItem: "Save Item",
        resetAllWarning: "Reset All Entries?",
        resetAllWarningsubTitle:
          "This will clear all entered quantities and costs for the selected items.",
        resetAllWarningDesc: "This action cannot be undone.",
        resetAllWarningCancel: "Cancel",
        resetAllWarningReset: "Reset All",
        quantity: "Quantity",
        unitCost: "Unit Cost",
        purchaseCost: "Purchase Cost",
        resetEntriesSuccessfullyTitle: "Entries Cleared Successfully",
        resetEntriesSuccessfullyDesc:
          "The form is now reset and ready for new entries.",
        quantityTooLong: "Quantity cannot exceed 10 digits",
        unitCostGreaterThanZero: "Unit Cost must be greater than 0",
        purchaseCostGreaterThanZero: "Purchase Cost must be greater than 0",
        quantityGreaterThanZero: "Quantity must be greater than 0",
      },
    },
    confirmCreationModal: {
      title: "Confirm Opening Inventory",
      subTitle: "Are you sure you want to submit this opening balance?",
      description:
        "Once submitted, the entered quantities will initialize inventory for these items. The Initial Average Current Cost (ACC) will be calculated and the item will become active in inventory tracking.",
      cancel: "No, Keep Editing",
      confirm: "Confirm & Initialize Inventory",
    },
    createSuccessModal: {
      title: "Opening Inventory Set Successfully",
      description: "Inventory tracking is now active.",
    },
    exitWithoutSavingModal: {
      title: "Exit Without Saving?",
      subTitle: "This form contains unsaved details.",
      description: "Exiting now will permanently delete all entered data.",
      cancel: "Discard & Exit",
      confirm: "Save draft",
    },
    saveDraftModal: {
      title: "Draft Saved!",
      subTitle: "Your progress has been saved as a draft.",
      description:
        "You can return later to continue editing the opening balance.",
      cancel: "Exit Form",
      confirm: "Continue Editing",
    },
    completeDraftModal: {
      title: "You have unfinished Opening Balance",
      subTitle: "You started opening balance but didn’t finish it.",
      description: "Complete the existing draft or open a new one.",
      cancel: "Set New Opening Balance",
      confirm: "Complete Form",
    },
    stockDetails: {
      consumptionByType: "Consumption by type",
      sinceOpeningBalance: "Since opening balance",
      allTime: "All time",
      totalConsumed: "Total Consumed",
      days: "days",
      movements: "Movements",
      SinceOpeningBalance: "Since Opening Balance",
      batchInput: "Batch Input",
      transferToBranch: "Transfer to Branch",
      negativeAdjustment: "Negative Adjustment",
      totalStockAdded: "Total Stock Added",
      totalStockAddedSubtitle:
        "All stock received and added since Opening Balance",
      totalQtyAdded: "Total Quantity Added",
      bySupplier: "By Supplier",
      otherAdditions: "Other Additions",
      positiveAdjustments: "Positive Adjustments",
      openingBalance: "Opening Balance",
      purchaseUomPackSize: "Purchase UOM / Pack Size",
      totalQty: "Total Qty",
      footnote:
        "*Percentage and quantity show the share of total quantity entered per supplier, based on all movement history since opening balance.",
    },
  },
  //receive transfer
  receiveTransfer: {
    create: {
      title: "Receive Transfer",
      step1Title: "Step 1",
      step1Subtitle: "Receive Items",
      step1Content:
        "Add received quantities and record any missing or rejected items.",
      step2Title: "Step 2",
      step2Subtitle: "Review & Confirm",
      step2Content:
        "Review all entries, add the delivery date, and confirm to update inventory.",
      step1: {
        itemName: "Item Name",
        sent: "Sent",
        delivered: "Delivered",
        accepted: "Accepted",
        rejected: "Rejected",
        missing: "Missing",
        remaining: "Remaining",
        rejectionReason: "Rejection Reason",
        viewEditReason: "View/Edit Reason",
      },
      step2: {
        createdOn: "Created On",
        actualDeliveryDate: "Actual Delivery Date",
        reviewItems: "Review Items",
        financialSummary: "Financial Summary",
        sentValue: "Sent Value",
        remainingValue: "Remaining Value",
        acceptedValue: "Accepted Value",
        inventoryUpdate: {
          title: "Inventory Update",
          description:
            "Only accepted quantities will be added to destination inventory. Missing or rejected quantities will be recorded as remaining.",
        },
        badges: {
          accepted: "Accepted",
          remaining: "Remaining",
          fullyMissed: "Fully Missed",
          fullyRejected: "Fully Rejected",
        },
      },
      footer: {
        fullyAccepted: "Fully Accepted",
        partiallyAccepted: "Partially Accepted",
        fullyMissed: "Fully Missed",
        fullyRejected: "Fully Rejected",
        itemTypes: "Item Types",
        acceptedAmount: "Accepted Amount",
        remaining: "Remaining",
      },
      confirmModal: {
        title: "Submit Receiving ?",
        description:
          "Accepted quantities will be added to destination inventory. Missing or rejected quantities will not enter inventory.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Submit Receiving",
      },
      fullyAcceptedSuccessModal: {
        title: "Transfer has been fully accepted",
        description:
          "Transfer received successfully. Destination stock has been updated.",
      },
      partiallyAcceptedSuccessModal: {
        title: "Transfer has been partially accepted",
        description: "Transfer partially accepted. Variance has been recorded.",
      },
    },
  },

  // create transfer branch
  createTransferBranch: {
    title: "Make Transfer",
    step1Title: "Step 1",
    step1Subtitle: "Add Items",
    step1Content: "Add the items you want to transfer.",
    step2Title: "Step 2",
    step2Subtitle: "Review & Confirm",
    step2Content: "Review all entries and confirm to send request.",
    addItemsHeader: {
      title: "Add Required Quantities",
    },
    addItemsTable: {
      availableStock: "Available Stock",
      transferQty: "Transfer Qty",
      totalBaseQty: "Total Base Qty",
      purchaseUomPackSize: "Purchase UOM / Pack Size",
      loosePackSize: "Loose / {{packSize}}",
      transferQtyPlaceholder: "Add Transfer Qty",
      transferQtyRequired: "Transfer quantity is required",
      transferQtyGreaterThanZero: "Transfer quantity must be greater than 0",
      transferQtyLessThanStock: "Transfer quantity exceeds available stock",
      noItems: "No Items Added Yet",
      transferAmount: "Transfer Amount",
    },
    addItemsModal: {
      title: "Add Items to Request",
      description: "Select items from one or more categories.",
      selectType: "Select Type",
    },
    footer: {
      itemsAdded: "Item Types Added",
      submit: "Submit Transfer",
      totalTransferAmount: "Total Transfer Amount",
    },
    confirmModal: {
      title: "Send Transfer",
      subTitle: "Are you sure you want to send this transfer?",
      description:
        "Once sent, stock will be deducted from the source location. Destination stock will increase only after receiving confirmation.",
      cancel: "No, Keep Editing",
      confirm: "Yes, Send Transfer",
    },
    successModal: {
      title: "Transfer sent successfully",
      description: "Your transfer has been sent and your inventory is updated.",
    },
    step2: {
      selectDestinationLocation: "Select Destination Location",
      selectBranchPlaceholder: "Select Branch",
      reviewTransferDetails: "Review Transfer Details",
      purchaseUomPackSize: "Purchase UOM / Pack Size",
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      stockUpdate: "Stock Update",
      stockUpdateDescription:
        "Stock will be deducted from the source location after confirming the transfer. Destination stock will increase only after receiving is accepted.",
    },
  },
  //prepared items
  preparedItems: {
    title: "Prepared Items",
    import: {
      importItems: "Import Prepared Items",
      importItemsSubtitle:
        "Upload a filled document to add multiple prepared items at once.",
      importItemsDescription:
        "Use this template to ensure your prepared items are formatted correctly before uploading.",
      validationErrors: {
        outputUOMRequired: "Output UOM is required",
        invalidOutputUOM: "Invalid Output UOM.",
        storageConditionRequired: "Storage Condition is required",
        invalidStorageCondition: "Invalid Storage Condition.",
        canUseRecipesRequired: "Can be used in Recipes is required",
        invalidYesNo: "Value must be yes or no",
      },
    },
    storageCondition: "Storage Condition",
    ingredientQty: "Ingredient Qty",
    outputUom: "Output UOM",
    dateFilter: "Date Filter",
    estQty: "Est. Qty",
    ingredients: "Ingredients",
    lastUpdatedDate: "Last Updated Date",
    recipe: "Recipe",
    recipeItems: "{{count}} Items",
    noItems: "No Items added yet",
    latestFirst: "Latest First",
    default: "Default",
    oldestFirst: "Oldest First",
    details: {
      itemDetails: "Item Details",
      startBatch: "Start Batch",
      finishSetup: "Finish Setup",
      outputUom: "Output UOM",
      outputUomDescription: "The unit in which the prepared item is produced.",
      canBeUsedInRecipes: "Can be used in recipes",
      statusActiveDescription:
        "This item is active and available for use and selection in the system.",
      statusInactiveDescription:
        "This item is inactive and not available for use in the system.",
      financialSummary: "Financial Summary",
      totalEstIngredientsCost: "Total Est. Ingredients Cost",
      estCostPerOutputUom: "Est. Cost per Output UOM",
      notesAndInstructions: "Notes & Instructions",
      defaultPrepTime: "Default Preparation Time",
      preparationInstructions: "Preparation Instructions",
      qualityNotes: "Quality Notes",
      attachments: "Attachments / Images",
      noIngredientsTitle: "No Ingredients Added Yet",
      noIngredientsDescription:
        "Ingredients are added during preparation setup.",
      noPrepDetailsTitle: "No preparation details yet",
      noPrepDetailsDescription:
        "Prep instructions, quality notes, and prep time will appear here once setup is complete.",
      noNotesOrInstructionsTitle: "No notes or instructions added",
      viewNotes: "View ingredient notes",
      ingredientNotes: "Ingredient Notes",
      tabs: {
        detailsAndIngredients: "Details & Ingredients",
        notesAndActivity: "Notes & Activity Log",
      },
      table: {
        itemName: "Item Name",
        baseUnit: "Base Unit",
        quantity: "Quantity",
        currentAcc: "Current ACC",
        estIngredientCost: "Est. Ingredient Cost",
        notes: "Notes",
      },
    },
    finishSetup: {
      title: "Set Up Preparation",
      submitSetup: "Submit Setup",
      setupCard: {
        itemsNeedSetup: "{{count}} items need setup",
        setUpAll: "Set up all",
      },
      step1: {
        title: "Step 1",
        description: "Ingredients.",
        content: "Select an item and add its ingredients.",
        sectionTitle: "Select Prepared Item",
        sectionSubtitle:
          "Choose a prepared item and add the ingredients required for preparation.",
        searchPlaceholder: "Search Name or SKU",
        ingredientsCount: "Ingredients Count",
        addIngredients: "Add Ingredients",
        noIngredientsAdded: "No Ingredients Added Yet",
        viewEditNotes: "View / Edit",
        addNotes: "Add notes",
        addItemsModal: {
          title: "Add Ingredients to Prepared Items",
          description:
            "Select items from one or more categories to set ingredients quantity & notes.",
        },
        notesDrawer: {
          title: "Add Notes",
          description:
            "Optional notes on handling or prep for this ingredient.",
          placeholder: "Enter handling or prep notes...",
          characters: "characters",
          submit: "Submit Notes",
        },
      },
      step2: {
        title: "Step 2",
        description: "Output & Prep.",
        content: "Set output quantity and preparation instructions.",
        sectionTitle: "Set Output Quantity & Prep Instructions",
        outputName: "Output Name",
        estimatedQuantity: "Estimated Quantity",
        prepInstructions: "Prep Instructions",
        addPrep: "Add prep instructions",
        viewEditPrep: "View / Edit",
        noItems: "No items with saved ingredients yet.",
        prepModal: {
          title: "Preparation Instructions",
          submit: "Submit Instructions",
          defaultPrepTimeDescription:
            "The standard preparation time for this item.",
          prepInstructionsPlaceholder:
            "Enter step-by-step preparation instructions...",
          preparationSteps: "Preparation Steps",
          prepStepsPlaceholder: "Enter step-by-step preparation notes...",
          qualityNotesPlaceholder:
            "Texture, color, smell, temperature, or visual checks,etc...",
          dropzoneText: "Drop images or PDFs here to upload",
          attachmentsHint: "Images and PDF files are supported.",
        },
      },
      step3: {
        title: "Step 3",
        ingredientsWithCount: "Ingredients ({{count}})",
        description: "Review & Submit.",
        content: "Review all items and submit.",
        sectionTitle: "Review Preparation Setup",
        totalQuantity: "Total Quantity",
        noItems: "No items are ready to submit yet.",
        ingredientsSummary: "Ingredients",
        prepDetails: "Preparation Details",
        defaultPrepTime: "Default Prep Time",
        qualityNotes: "Quality Notes",
        attachments: "Attachments",
        attachmentsCount: "{{count}} file(s)",
        prepAdded: "Added",
        noPrep: "Not added",
        noNotes: "—",
      },
      confirmModal: {
        title: "Confirm Prepared Item Setup Submission",
        subtitle: "Are you sure you want to submit these items?",
        description:
          "Once submitted, the items will be added to the inventory and will become available for use in transfers.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Submit Items",
      },
      successModal: {
        title: "Preparation Setup has been completed successfully",
        description:
          "Items setup is completed, now it's ready for inventory tracking or transfers yet.",
        itemsCompletedTitle:
          "{{count}} items setup has been completed successfully",
        itemsCompletedDescription:
          "These {{count}} items are now ready for inventory tracking and transfers.",
        remainingNotePrefix: "*{{count}} items still need setup:",
        remainingNoteSuffix:
          "you can continue now or come back to them anytime from the prepared items list.",
        viewItem: "View Item",
        viewItems: "View Items",
        setUpRemaining: "Set Up Remaining",
      },
      footer: {
        itemsWithIngredients: "{{count}} / {{total}} items with ingredients",
        itemsCompleted: "{{count}} / {{total}} Items Completed",
        itemsReadyToSubmit: "{{count}} items ready to submit",
      },
      exitWithoutSavingModal: {
        title: "Exit Without Saving?",
        subTitle: "This form contains unsaved details.",
        description: "Exiting now will permanently delete all entered data.",
        cancel: "Keep editing",
        confirm: "Discard & Exit",
      },
      saveDraftModal: {
        title: "Draft Saved!",
        subTitle: "Your progress has been saved as a draft.",
        description:
          "You can return later to continue editing the preparation setup.",
        cancel: "Exit Form",
        confirm: "Continue Editing",
      },
      completeDraftModal: {
        title: "You have unfinished preparation setup!",
        subTitle: "You started setting up items but didn't finish.",
        description:
          "Complete the existing draft or start a new preparation setup.",
        cancel: "Start New Setup",
        confirm: "Complete Form",
      },
    },
    create: {
      title: "Create Prepared Item",
      addItemNames: "Add Prepared Item Names",
      addItemDetails: "Add Prepared Item Details",
      Step2Content:
        "Set units, storage requirements, and recipe usage settings for this prepared item.",
      outputUomPlaceholder: "Select Unit (kg, liter, piece, etc)",
      canBeUsedInRecipesHint:
        "Controls whether this item can be selected in recipes.",
      storageConditionPlaceholder: "Select (Chilled, Frozen, etc)",
      storageConditionHint: "The recommended storage condition for this item.",
      inRecipes: "In Recipes",
      notInRecipes: "Not in Recipes",
      branchVisible: "Branch-Visible",
      notBranchVisible: "Not Branch-Visible",
      selectPreparedItems: "Select Prepared Item/s",
      mixedSelections: "Mixed Selections",
      confirmItemsSubmissionModal: {
        title: "Confirm Item Submission",
        subtitle: "Are you sure you want to submit these items?",
        description:
          "Once submitted, the items will be added to the inventory and will become available for use in transfers.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Submit Items",
      },
      successModal: {
        title: "Prepared Items added successfully",
        subtitle: "*To start using it, create a Preparation Setup.",
        description:
          "Your item was added, but it’s not ready for inventory tracking or transfers yet.",
        cancel: "View Items",
        confirm: "Set Up Preparation",
      },
    },
    edit: {
      title: "Edit Prepared Item",
      itemNames: "Prepared Item Names",
      successModal: {
        title: "Prepared Item has been updated successfully",
        description:
          "Your changes have been saved. The prepared item details are now up to date.",
        viewItem: "View Item",
      },
      steps: {
        ingredients: "Ingredients",
        outputAndPrep: "Output & Prep",
        review: "Review",
      },
      confirmModal: {
        title: "Confirm Item Update",
        subtitle: "Are you sure you want to save these changes?",
        description: "The prepared item details will be updated.",
        cancel: "No, Keep Editing",
        confirm: "Yes, Save Changes",
      },
    },
  },
  //batch details
  batchDetails: {
    recordOutput: "Record Output",
    tabs: {
      quantity_ingredients: "Quantity & Ingredients",
      details_activity: "Details & Activity Log",
    },
    quantitySummary: "Quantity Summary",
    plannedOutput: "Planned Output",
    actualOutput: "Actual Output",
    varianceQty: "Variance Qty",
    actualYield: "Actual Yield",
    lossReason: "Loss Reason",
    noProductionDetailsYet: "No production details yet",
    noProductionDetailsDescription:
      "These values will appear once production is complete.",
    otherExplanation: "Other explanation",
    financialSummary: "Financial Summary",
    actualQty: "Actual Qty",
    totalProductionCost: "Total Production Cost",
    actualCostPerOutputUom: "Actual Cost / Output UOM",
    ingredients: "Ingredients",
    table: {
      name: "Item Name",
      plannedQty: "Planned Qty",
      currentAcc: "Current ACC",
      estIngredientCost: "Est. Ingredient Cost",
    },
    batchDetails: "Batch Details",
    outputUom: "Output UOM",
    outputUomDescription: "The unit in which the prepared item is produced.",
    outputSku: "Output SKU",
    productionDate: "Production Date",
    productionDateDescription: "Date entered during Record Output",
    completedBy: "Completed by",
    notesAndInstructions: "Notes & Instructions",
    productionNotes: "Production Notes",
    attachments: "Attachments / Images",
    noNotes: "No notes or instructions yet",
    noNotesDescription:
      "Production notes and attachments will appear here once production is complete.",
    activity: {
      planCreated: "Production Plan Created",
      produceCompleted: "Produce Output Completed",
      lossRecorded: "Production Loss Recorded",
      recordOutputCompleted: "Record Output Completed",
      updated: "Batch Updated",
    },
  },
  // Cost Centers
  costCenters: {
    title: "Cost Centers",
    createCostCenter: "Create Cost Center",
    centerName: "Center Name",
    code: "Code",
    description: "Description",
    budget: "Budget",
    spent: "Spent",
    remaining: "Remaining",
    parent: "Parent Cost Center",
  },

  // Expenses
  expenses: {
    title: "Expenses",
    createExpense: "Create Expense",
    editExpense: "Edit Expense",
    description: "Description",
    amount: "Amount",
    currency: "Currency",
    date: "Date",
    costCenter: "Cost Center",
    category: "Category",
    attachments: "Attachments",
    approvedBy: "Approved By",
    createdBy: "Created By",
  },

  // Settings
  settings: {
    title: "Settings",
    general: "General",
    appearance: "Appearance",
    language: "Language",
    theme: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
    notifications: "Notifications",
    security: "Security",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
  },

  // Roles
  roles: {
    super_admin: "Super Admin",
    admin: "Admin",
    branch_manager: "Branch Manager",
    branch_staff: "Branch Staff",
    ck_manager: "CK Manager",
    ck_staff: "CK Staff",
    guest: "Guest",
  },

  // Profile
  profile: {
    title: "Profile",
    editProfile: "Edit Profile",
    avatar: "Avatar",
    personalInfo: "Personal Information",
    accountSettings: "Account Settings",
    role: "Role",
    branch: "Branch",
    joinedOn: "Joined on {{date}}",
  },

  // Languages
  languages: {
    en: "English",
    ar: "Arabic",
  },

  // Errors
  errors: {
    unauthorized: "You are not authorized to access this page",
    forbidden: "Access denied",
    notFound: "Page not found",
    serverError: "Server error. Please try again later.",
    networkError: "Network error. Please check your connection.",
    sessionExpired: "Your session has expired. Please log in again.",
  },

  currency: {
    AED: "AED",
    USD: "USD",
    EUR: "EUR",
    SAR: "SAR",
  },

  // DatePicker / Calendar
  datePicker: {
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    daysOfWeek: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  },

  producedOutput: {
    title: "Produced Output",
    produceOutput: "Produce Output",
    searchPlaceholder: "Search by Batch #, Output name, Output SKU",
    filterVariance: "Filter Variance",
    filterProductionDate: "Production Date",
    selectCategory: "Select Category",
    selectSubcategory: "Select Subcategory",
    noVariance: "No Variance",
    preparationLoss: "Preparation Loss",
    variancePositive: "Positive",
    varianceNegative: "Negative",
    totalItems: "Total: {{count}} Items",
    awaitingCount: "{{count}} Awaiting Output",
    recordOutput: "Record Output",
    exportSuccess: "Produced output exported successfully",
    status: {
      awaiting: "Awaiting Output",
      completed: "Completed Output",
    },
    awaiting: {
      actualYield: "Awaiting production to finish",
      variance: "Recorded on completion",
      actualCostPerUom: "Calculated on completion",
    },
    columns: {
      batchNumber: "Batch #",
      outputName: "Output Name",
      actualYield: "Actual Yield",
      variance: "Variance",
      totalProductionCost: "Total Production Cost",
      actualCostPerUom: "Actual Cost / Output UOM",
      productionDate: "Production Date",
      actions: "Actions",
    },
    emptyState: {
      title: "Nothing produced yet",
      description:
        "Produced output from your prepared items will be listed here. Start by selecting a prepared item and producing its output.",
      createButton: "Produce Output",
      noResults: "No results found",
    },
    export: {
      batchNumber: "Batch #",
      outputName: "Output Name",
      status: "Status",
      actualYield: "Actual Yield",
      variance: "Variance",
      totalProductionCost: "Total Production Cost",
      actualCostPerUom: "Actual Cost / Output UOM",
      productionDate: "Production Date",
    },
    produceFlow: {
      formTitle: "Produce Output - {{details}}",
      submit: "Submit",
      costUnavailable: "Unavailable",
      selectItem: {
        title: "Select Item to Produce",
        description:
          "Choose the prepared item you want to produce. Setup quantity and ingredients will be retrieved automatically.",
        preparedItemColumn: "Select Prepared Item",
        startProduction: "Start Production",
      },
      steps: {
        setPlannedQty: {
          step1: "Step 1",
          title: "Set Planned Qty",
          description:
            "Set the planned qty and review ingredient qty, costs and stock.",
        },
        reviewOutput: {
          step2: "Step 2",
          title: "Review Output",
          description: "Review the production output before completion.",
          placeholder: "Review output step coming soon.",
        },
        recordOutput: {
          step2: "Step 2",
          title: "Record Output",
          description:
            "Set the Actual qty, complete production details and review the output before submitting.",
        },
      },
      plannedQty: {
        sectionTitle: "Planned output quantity",
        formulaHint: "Planned Qty = Setup Qty × Batch Multiplier",
        plannedQtyLabel: "Planned Qty",
        placeholder: "e.g. 12",
        setupQtyLabel: "Setup Qty",
        setupQtySubtitle: "Retrieved from preparation setup",
        batchMultiplierLabel: "Batch Multiplier",
        batchMultiplierSubtitle: "Auto-calculated",
      },
      ingredients: {
        title: "Ingredients",
        countBadge: "{{count}} items",
        formulaHint: "Planned Qty = Setup Qty × <box>{{multiplier}}</box>",
        itemName: "Item Name",
        setupQty: "Setup Qty",
        plannedQty: "Planned Qty",
        availableStock: "Available Stock",
        currentAcc: "Current ACC",
        estimatedCost: "Est. Ingredient Cost",
        stockStatus: "Stock Status",
      },
      stockStatus: {
        available: "Available",
        insufficient: "Insufficient",
        outOfStock: "Out of Stock",
      },
      footer: {
        shortOnStock: "{{count}} ingredients are short on stock",
        insufficient: "{{count}} ingredients are insufficient",
      },
      confirmModal: {
        title: 'Confirm Production Plan for "{{itemName}}"',
        subtitle: "Are you sure you want to submit this plan?",
        description:
          "Once submitted, ingredient stock will be deducted from Central Kitchen. The actual output is recorded after production.",
        footnote: "*The action cannot be edited after completion",
        cancel: "No, Keep Editing",
        confirm: "Confirm & Save Plan",
      },
      confirmPurchaseUnits: {
        title: "Confirm Purchase Units",
        description:
          "Review the stock units that will be used for this production. You can adjust the selection if needed.",
        plannedQtyTitle: "{{name}} / Planned Qty",
        requiredQtyHint: "Required quantity for this production",
        shortfallWarning:
          "Entered quantity is {{amount}} {{unit}} short of the planned qty.",
        stockBreakdownTitle: "Available stock breakdown",
        stockBreakdownHint:
          "Review how the planned quantity will be deducted from available stock. Adjust the selection if needed.",
        packsAvailable: "{{count}} {{unit}}s available",
        conversionNote:
          "Any selected Purchase UOM / Pack will be converted to Loose / Base Quantity in inventory once used for production.",
        confirm: "Confirm & Start Production",
      },
      successModal: {
        title: 'The Production plan for "{{itemName}}" is saved',
        description:
          "Print the prep sheet and start preparation in the kitchen. When production is done, come back to record the actual output.",
        viewDetails: "View details",
        printPlan: "Print Plan",
      },
      planPdf: {
        title: "{{itemName}} Production Plan",
        preparedItem: "Prepared Item",
        sku: "SKU",
        plannedQty: "Planned Qty",
        outputUom: "Output UOM",
        ingredientName: "Item Name",
        ingredientPlannedQty: "Planned Qty",
      },
      exitWithoutSaving: {
        title: "Exit Without Saving?",
        subTitle: "This form contains unsaved Data.",
        description: "Exiting now will permanently delete all entered data.",
        cancel: "Discard & Exit",
        confirm: "Stay",
      },
      confirmSubmitRecordModal: {
        title: "Confirm {{itemName}} Output Production",
        subtitle: "Are you sure you want to submit this output production?",
        description:
          "Once submitted, the actual produced quantity will be added to inventory.",
        footnote: "*The action cannot be edited after completion",
        cancel: "No, Keep Editing",
        confirm: "Yes, Submit Production",
      },
      recordOutputSuccessModal: {
        title: "{{itemName}} Output Production Confirmed",
        description: "Produce Output is completed, inventory stock is updated.",
        viewDetails: "View details",
      },
      recordOutput: {
        sectionTitle: "Actual produced Quantity",
        actualQtyLabel: "Actual Qty",
        actualQtyHint: "The final quantity produced after preparation.",
        productionDateHint: "When and how this run was produced.",
        actualQtyPlaceholder: "e.g 12",
        lossReasonLabel: "Loss Reason",
        lossReasonPlaceholder: "Select Reason",
        lossReasonOtherLabel: "Other explanation",
        lossReasonOtherPlaceholder: "Describe the loss reason",
        productionInfoTitle: "Production Information",
        productionDateLabel: "Production Date",
        productionNotesLabel: "Production Notes",
        productionNotesPlaceholder:
          "Add any notes about this production run: preparation details, ingredient changes, or issues encountered.",
        attachmentsLabel: "Attachments / Images",
        outputSummaryTitle: "Output Summary",
        plannedOutput: "Planned Output",
        actualOutput: "Actual Output",
        varianceQty: "Variance Qty",
        varianceFormula: "Actual Qty - Planned Qty",
        actualYield: "Actual Yield",
        totalIngredientsCost: "Total Ingredients cost",
        actualCostPerUom: "Actual Cost / Output UOM",
        validation: {
          actualQtyRequired: "Actual Qty is required",
          actualQtyInvalid: "Enter a valid decimal quantity",
          actualQtyPositive: "Actual Qty cannot be zero or negative",
          actualQtyExceedsPlanned:
            "Actual Qty cannot be greater than Planned Output Qty",
          productionDateRequired: "Production Date is required",
          lossReasonRequired: "Loss Reason is required",
          lossReasonOtherRequired: "Please describe the loss reason",
        },
        footer: {
          noVariance:
            "Output matches the planned quantity. No variance recorded.",
          productionLoss:
            "Production loss was recorded. {{qty}} {{uom}} (-{{percentage}}%) below plan.",
        },
      },
    },
  },
};
